// extracted by mini-css-extract-plugin
export default {"profileSettings":"Styles-module__profileSettings--8d37","settings":"Styles-module__settings--00b6","description":"Styles-module__description--abbc"};